import styled from 'styled-components'
import tw from 'twin.macro'
import { Button } from '@nw/omega-design-system'

export const Container = styled.div`
  ${tw`flex flex-col justify-center items-center rounded-16px font-inter pt-16 pb-12 bg-white w-[607px] relative`};
  @media (max-width: 1000px) {
    ${tw`w-full`}
  }
  background-image: url(${(props) => props.bgImage});
`

export const Heading = styled.span`
  ${tw`text-xl leading-7 font-semibold text-darkLightBlueGray mt-4 mb-2 text-center`};
`

export const Description = styled.span`
  ${tw`text-sm leading-5 font-normal text-lightBlueGray mb-8 text-center`};
`

export const CloseIconWrapper = styled.div`
  ${tw`p-4 cursor-pointer top-[8px] right-[8px] absolute`};
`

export const StyledButton = styled(Button)`
  ${tw`rounded-lg`}
`
